import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface IconProps extends React.SVGAttributes<SVGElement> {
  size?: IconSize;
  color?: string;
}

const sizeMap: Record<IconSize, string> = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
};

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ size = 'md', color, className, children, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke={color ?? 'currentColor'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn(sizeMap[size], className)}
        aria-hidden="true"
        {...props}
      >
        {children}
      </svg>
    );
  },
);

Icon.displayName = 'Icon';
